import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { useTemplateFuzzySearchContext } from "@/components/confluence/templates/context/template-fuzzy-search-context.tsx";
import { TemplateFuzzySearch } from "@/components/confluence/templates/template-fuzzy-search.tsx";
import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages.ts";

const containerStyles = css({
    display: "flex",
    justifyContent: "center"
});

const variantHeaderStyles = css({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "20px",
    marginBlock: "45px",
    paddingInline: "4px",
    width: "1304px",
    background: `url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg_atl_cloud_hero_small.svg) center/cover no-repeat`,
    color: "#FFFFFF",
    minHeight: "298px",
    padding: "42px",
    marginInline: "78px",
    [media.below.lg]: {
        marginInline: "32px"
    },
    [media.below.sm]: {
        marginInline: "24px"
    },
    [media.below.xs]: {
        marginInline: "16px"
    }
});

const titleStyles = css({
    margin: "0",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontWeight: "500",
    fontSize: "52px",
    [media.below.sm]: {
        fontSize: "36px"
    }
});

const subTitleStyles = css({
    margin: "0",
    fontWeight: "400",
    fontSize: "20px",
    [media.below.sm]: {
        fontSize: "16px",
        width: "268px"
    }
});

const TemplateHeroSection = () => {
    const { currentCategory } = useTemplateFuzzySearchContext();

    const isDefaultCategory = [
        "recommended",
        "business-strategy",
        "productivity",
        "docs-and-reports",
        "startup",
        "personal",
        "project-planning"
    ].includes(currentCategory?.urlSlug as string);

    return (
        <div css={containerStyles}>
            <header css={variantHeaderStyles}>
                <h1 css={titleStyles}>
                    <FormattedMessage
                        {...(isDefaultCategory
                            ? ConfluenceTemplateMessages.defaultHeaderText
                            : ConfluenceTemplateMessages.headerText)}
                        values={{ categoryName: currentCategory?.name ?? "" }}
                    />
                </h1>
                <p css={subTitleStyles}>
                    <FormattedMessage
                        {...ConfluenceTemplateMessages.subHeaderText}
                    />
                </p>
                <TemplateFuzzySearch />
            </header>
        </div>
    );
};
TemplateHeroSection.displayName = "TemplateHeroSection";
export { TemplateHeroSection };
